import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  SupplierAllocationsUpdate,
  SupplierBlendSave,
  SupplierGroupTemplateSave,
  SupplierManagedAllocationsUpdate,
} from '@ps/survey-utils';

import { SupplierActions } from './supplier.actions';

@Injectable({ providedIn: 'root' })
export class SupplierActionsFacade {
  private readonly _store = inject(Store);

  // Allocations and the flexibility price params back the same drawer, so they
  // load together — the from-state save needs both.
  public loadAllocations(surveyId: number): void {
    this._store.dispatch(
      SupplierActions.loadAllocations({ surveyId, params: { scope: 'view' } }),
    );
    this.loadFlexibilityPriceParams(surveyId);
  }

  public loadBlends(locale: string): void {
    this._store.dispatch(SupplierActions.loadBlends({ locale }));
  }

  public loadGroupTemplates(): void {
    this._store.dispatch(SupplierActions.loadGroupTemplates());
  }

  public loadFlexibilityPriceParams(surveyId: number): void {
    this._store.dispatch(
      SupplierActions.loadFlexibilityPriceParams({ surveyId }),
    );
  }

  public updateAllocations(
    surveyId: number,
    update: SupplierAllocationsUpdate,
  ): void {
    this._store.dispatch(
      SupplierActions.updateAllocations({ surveyId, update }),
    );
  }

  public updateManagedAllocations(
    surveyId: number,
    update: SupplierManagedAllocationsUpdate,
  ): void {
    this._store.dispatch(
      SupplierActions.updateManagedAllocations({ surveyId, update }),
    );
  }

  public saveGroupAsTemplate(data: SupplierGroupTemplateSave): void {
    this._store.dispatch(SupplierActions.saveGroupAsTemplate({ data }));
  }

  public saveBlend(data: SupplierBlendSave): void {
    this._store.dispatch(SupplierActions.saveBlend({ data }));
  }

  public resetAllocations(): void {
    this._store.dispatch(SupplierActions.resetAllocations());
  }
}
